import {
  CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis,
} from "recharts";
import { bucketLabel } from "../format";
import { AXIS_TEXT, GRID, SERIES } from "../theme";
import { Bucket, Point } from "../types";

/** Up to three counts over time on one axis, with a crosshair tooltip. */
export default function SeriesChart({ points, lines, bucket, height = 260 }: {
  points: Point[]; lines: Array<{ key: string; label: string }>; bucket: Bucket; height?: number;
}) {
  const tick = { fill: AXIS_TEXT, fontSize: 12 };
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={points} margin={{ top: 8, right: 16, bottom: 0, left: 0 }}>
        <CartesianGrid stroke={GRID} vertical={false} />
        <XAxis dataKey="t" tickFormatter={(t) => bucketLabel(String(t), bucket)} tick={tick} stroke={GRID} minTickGap={24} />
        <YAxis allowDecimals={false} tick={tick} stroke={GRID} width={48} />
        <Tooltip labelFormatter={(t) => bucketLabel(String(t), bucket)} itemStyle={{ color: AXIS_TEXT }} />
        {lines.length > 1 && <Legend formatter={(value) => <span style={{ color: AXIS_TEXT }}>{value}</span>} />}
        {lines.slice(0, SERIES.length).map((line, i) => (
          <Line
            key={line.key} type="monotone" dataKey={line.key} name={line.label}
            stroke={SERIES[i]} strokeWidth={2} dot={false} activeDot={{ r: 4 }} isAnimationActive={false}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}
